<template>
  <div class="mainWarp">
    <div class="img-title">
      <img src="~@/assets/bigusers/largeScreen//redTitle.png" />
      <span class="DataTitle">大用户异常报警</span>
    </div>
    <div class="content">
      <div class="chart-container">
        <div style="height: 100%; margin: 20px 24px;">
          <div class="tableTab">
            <div class="table-row">
              <div class="table-cell">报警地址</div>
              <div class="table-cell">报警类型</div>
              <div class="table-cell">报警说明</div>
              <div class="table-cell">报警时间</div>
            </div>
          </div>
          <div class="table-content-wrapper" ref="tableWrapper" @mouseenter="pauseAnimation"
            @mouseleave="resumeAnimation">
            <div class="table-content" :style="{ transform: `translateY(${translateY}px)` }">
              <div class="table-content-row" v-for="(item, index) in displayData" :key="index"
                @click="handleRowClick(item)">
                <div class="table-content-cell cell-address">{{ item.userAddress }}</div>
                <div class="table-content-cell cell-img">
                  <img :src="item.waterType == 1
                    ? require('@/assets/bigusers/largeScreen/alarm1.png')
                    : require('@/assets/bigusers/largeScreen/alarm2.png')" />
                  {{ item.waterType == 1 ? '水量异常' : '数据中断' }}
                </div>
                <div class="table-content-cell cell-address">{{ item.alarmInstructions }}</div>
                <div class="table-content-cell">{{ item.startTime }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="top"></div>
      <div class="middle"></div>
      <div class="bottom"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomAlarm',
  data () {
    return {
      alarmUrl: '/smart-water-major-users/major/users/alarm/alarm_info/select/page',
      alarmData: [
        // { id: 1, address: '城南小区1栋12楼1208号', type: 1, notes: '水量波动比例为50%', time: '2025.03.07 22:00:03' },
        // { id: 2, address: '江南学府小区1栋10楼1002号', type: 2, notes: '数据存在缺失', time: '2025.03.07 22:00:03' },
        // { id: 3, address: '城南小区1栋12楼1209号', type: 1, notes: '水量波动比例为50%', time: '2025.03.07 22:00:03' },
        // { id: 4, address: '城南小区1栋12楼1210号', type: 1, notes: '水量波动比例为50%', time: '2025.03.07 22:00:03' },
        // { id: 5, address: '城南小区1栋12楼1211号', type: 1, notes: '水量波动比例为50%', time: '2025.03.07 22:00:03' },
        // { id: 6, address: '城北小区2栋5楼508号', type: 2, notes: '数据存在缺失', time: '2025.03.07 22:05:03' },
        // { id: 7, address: '城东小区3栋8楼812号', type: 1, notes: '水量波动比例为60%', time: '2025.03.07 22:10:03' },
      ],
      translateY: 0,
      animationInterval: null,
      rowHeight: 45, // 每行的高度，根据实际情况调整
      visibleRows: 4, // 可视区域显示的行数
      currentIndex: 0,
      isPaused: false, // 是否暂停动画
    };
  },
  computed: {
    displayData () {
      // 为了无缝滚动，需要复制数据
      return [...this.alarmData, ...this.alarmData.slice(0, this.visibleRows)];
    }
  },
  mounted () {
    this.getAlarmData();
    this.startAnimation();
    // 监听窗口大小变化，重新计算
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy () {
    this.stopAnimation();
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    startAnimation () {
      this.stopAnimation(); // 先停止之前的动画
      this.animationInterval = setInterval(() => {
        // 如果暂停状态，不执行动画
        if (this.isPaused) {
          return;
        }

        this.currentIndex++;
        if (this.currentIndex > this.alarmData.length) {
          this.currentIndex = 0;
          this.translateY = 0; // 重置位置
        } else {
          this.translateY = -this.currentIndex * this.rowHeight;
        }
      }, 2000); // 2秒滚动一次
    },
    stopAnimation () {
      if (this.animationInterval) {
        clearInterval(this.animationInterval);
        this.animationInterval = null;
      }
    },
    handleResize () {
      // 可以根据需要调整行高或可见行数
      // 这里可以添加响应式逻辑
    },
    getAlarmData () {
      this.$http.get(this.alarmUrl, {
        params: {
          page: 1,
          limit: 20,
          processingStatus: 1
        }
      }).then(res => {
        this.total = Number(res.data.total);
        this.alarmData = res.data.list
      })
    },
    // 暂停动画
    pauseAnimation () {
      this.isPaused = true;
    },
    // 恢复动画
    resumeAnimation () {
      this.isPaused = false;
    },
    handleRowClick (item) {
      this.$router.push({ path: '/big-users/workbench/userAlarm', query: { userCode: item.userCode } });
    }
  }
};
</script>

<style lang="less" scoped>
.mainWarp {
  height: 220px;
  width: 789px;
  position: relative;

  .content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .chart-container {
    position: absolute;
    top: 25px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }

  .top {
    flex: 0 0 60px;
    background: url(~@/assets/bigusers/largeScreen/redTopBox.png) no-repeat;
    background-size: 100% 100%;
  }

  .middle {
    flex: 0 0 70%;
    background: url(~@/assets/bigusers/largeScreen/redMiddleBox.png) repeat;
    background-size: 100% auto;
  }

  .bottom {
    flex: 0 0 60px;
    background: url(~@/assets/bigusers/largeScreen/redBottomBox.png) no-repeat;
    background-size: 100% 100%;
  }

  .img-title {
    position: absolute;
    top: -24px;
    left: calc(26% + 3px);
    transform: translateX(-50%);
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #FBD8DB;
    font-weight: 600;
    line-height: 30px;
    z-index: 1;

    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }

    img {
      width: 264px;
      height: 35px;
    }
  }
}

.tableTab {
  height: 35px;
  width: 100%;
  background: linear-gradient(to right, rgba(166, 13, 13, 0.64), rgba(166, 13, 13, 0.08));
}

.table-row {
  display: flex;
  height: 100%;
  align-items: center;
}

.table-cell {
  font-size: 18px;
  color: #FBD8DB;
  font-family: 'MicrosoftYaHei';
  flex: 1;
  text-align: center;
  padding: 8px;
}

.table-content-wrapper {
  height: 180px;
  overflow: hidden;
  position: relative;
}

.table-content {
  transition: transform 0.5s ease;
  will-change: transform;
}

.table-content-cell {
  font-size: 15px;
  color: white;
  font-family: 'MicrosoftYaHei';
  font-weight: 300;
  flex: 1;
  text-align: center;
  padding: 8px;
  line-height: 17.5px;
  transition: color 0.3s ease;
}

.table-content-row:hover .table-content-cell {
  color: #FFE4E6;
  font-weight: 400;
}

.table-content-row {
  margin: 10px 0;
  height: 35px;
  display: flex;
  border: 1px solid rgba(231, 82, 89, 0.4);
  box-shadow:
    inset 10px 0px 10px rgba(161, 4, 11, 0.2),
    inset -10px 0px 10px rgba(161, 4, 11, 0.2),
    inset 0px 10px 10px rgba(161, 4, 11, 0.2),
    inset 0px -10px 10px rgba(161, 4, 11, 0.2);
  transition: all 0.3s ease;
  cursor: pointer;
}

.table-content-row:hover {
  background: rgba(231, 82, 89, 0.3);
  border: 1px solid rgba(231, 82, 89, 0.8);
  box-shadow:
    inset 10px 0px 10px rgba(161, 4, 11, 0.4),
    inset -10px 0px 10px rgba(161, 4, 11, 0.4),
    inset 0px 10px 10px rgba(161, 4, 11, 0.4),
    inset 0px -10px 10px rgba(161, 4, 11, 0.4),
    0 0 10px rgba(231, 82, 89, 0.5);
  transform: scale(1.02);
}

.cell-img {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.cell-img img {
  width: 21px;
  height: 25px;
  object-fit: contain;
}

.cell-address {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>